import { mapState, mapActions } from 'vuex'
import { cloneDeep, isEmpty } from 'lodash'
import formButton from '@/components/common/form-button/form-button.vue'
import Multiselect from 'vue-multiselect'
import VJsoneditor from '@/components/common/json-editor'
import router from '@/router'

export default {
  components: {
    formButton,
    Multiselect,
    VJsoneditor
  },
  data() {
    return {
      workflow: {}
    }
  },
  computed: {
    ...mapState('workflow', ['currentlyEditedWorkflow'])
  },
  methods: {
    ...mapActions('workflow', ['updateWorkflow', 'deleteWorkflow']),
    isEmpty,
    onSaveWorkflow: async function () {
      try {
        await this.updateWorkflow({
          id: this.currentlyEditedWorkflow.id,
          data: this.workflow
        })
        this.$notify({
          text: 'Workflow successfully updated',
          type: 'success'
        })
      } catch (e) {
        this.$notify({
          text: 'Error while updating workflow',
          type: 'error'
        })
      }
    },
    onDeleteWorkflow: async function () {
      try {
        await this.$dialog.confirm(
          'This action may affect ongoing competitions. Do you really want to delete this workflow?'
        )
        await this.deleteWorkflow({ id: this.currentlyEditedWorkflow.id })
        this.$notify({
          text: 'Workflow successfully deleted',
          type: 'success'
        })
        router.push({ name: 'workflows' })
      } catch (e) {
        this.$notify({
          text: 'Error while deleting workflow',
          type: 'error'
        })
      }
    }
  },
  created() {
    this.workflow = cloneDeep(this.currentlyEditedWorkflow)
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/settings/workflows/workflow-edit/workflow-edit.js